export default __webpack_public_path__ + "199b16e32d9b2bc5650fc59a6d0d42ac.png";